import { useTranslation } from "react-i18next";
import { faDownload } from "@fortawesome/pro-light-svg-icons";
import { VaporIcon } from "@vapor/react-icons";
import { Stack, Box, Typography, useTheme } from "@vapor/react-material";
import { useCallback } from "react";
import { downloadFile } from "../../../../../../core/utils/downloadFile";
import { useDownloadTaxSubmissionFiles } from "../../../../../../core/api/use-download-tax-submission-files/useDownloadTaxSubmissionFiles";

export const useGetCtaDownloadFiles = (taxSubmissionId: string) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const downloadFilesMutation = useDownloadTaxSubmissionFiles();

    const onClickDownloadFiles = useCallback(async () => {
        try {
            const resourceData =
                await downloadFilesMutation.mutateAsync(taxSubmissionId);

            const filename: string =
                t("views.home.components.filename.files") +
                " " +
                taxSubmissionId;

            await downloadFile(
                resourceData.content,
                filename,
                resourceData.type,
            );
        } catch {
            // error notification already shown by handleHttpError
        }
    }, [downloadFilesMutation, taxSubmissionId, t]);

    return {
        element: (
            <Stack direction="row" onClick={onClickDownloadFiles}>
                <VaporIcon icon={faDownload} color="interactive" />
                <Box sx={{ mr: 1 }} />
                <Typography color={theme.palette.primary.interactiveDefault}>
                    {t(
                        "views.home.components.tax_submission_detail_toolbar.other_actions.download_files",
                    )}
                </Typography>
            </Stack>
        ),
        loading: downloadFilesMutation.isPending,
    };
};
